// ponytail: copied from apps/tasks/src/features/tickets/pageStyles.ts; move to a shared package if a third app needs it.
/**
 * The elka-manager new-order page look (OrderForm asPage), in calm tokens:
 * gray-200 → line, gray-900 → ink, gray-700 → ink-2, gray-500 → muted, white → surface.
 * Full literal class strings, so Tailwind's scanner picks them up.
 */

/** White content card. */
export const PAGE_CARD = 'border-line bg-surface rounded-xl border p-5';

/** The 28px page title (order page h1). */
export const PAGE_TITLE = 'text-ink text-[28px] leading-9 font-extrabold tracking-tight';

/** A borderless input that reads as the 28px title. */
export const TITLE_INPUT =
  'text-ink placeholder:text-sub w-full bg-transparent text-[28px] leading-9 font-extrabold tracking-tight outline-none';

/** Field label above a control. */
export const FIELD_LABEL = 'text-ink-2 mb-2 block text-sm font-medium';

/** Multi-line field (order page comments textarea). */
export const FIELD_TEXTAREA =
  'border-line bg-surface-soft text-ink placeholder:text-sub focus:ring-brand w-full rounded-xl border px-4 py-3 text-base transition-[border-color,box-shadow] focus:border-transparent focus:ring-2 focus:outline-none';

/** Small uppercase section heading inside a card. */
export const SECTION_TITLE = 'text-muted text-sm font-bold tracking-wide uppercase';

/** Inline error banner (order page errorBox). */
export const ERROR_BOX = 'border-danger/30 bg-danger-soft text-danger rounded-xl border px-4 py-3';

/** Muted keyboard-shortcut hint. */
export const KEY_HINT = 'text-muted text-xs';
